import { Box, Grid, GridItem, Spacer, Text } from "@chakra-ui/react"
import { FC, useEffect, useState } from "react";
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation";

type Props={
  length: number;
}

export const Clock:FC<Props>=(props)=>{
    const [currentTime, setCurrentTime] = useState(new Date());
    const {length} = props


    const width = WidthCalculation(324,430)
    const height =HeightCalculation(160,300)

    useEffect(() => {
      const timer = setInterval(() => {
        setCurrentTime(new Date());
      }, 1000);
  
      return () => {
        clearInterval(timer);
      };
    }, []);
  
    const formattedTime = `${currentTime.getHours().toString().padStart(2, '0')}:${currentTime.getMinutes().toString().padStart(2, '0')}`;
    const year = currentTime.getFullYear();
    const month = currentTime.getMonth() + 1;
    const day = currentTime.getDate();
    const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][currentTime.getDay()];
    if(length < 2){
      if(window.innerWidth > window.innerHeight){
        return (
          // 固定カード欄の時間表示(横長)
          <Grid 
          textAlign="center" 
          borderRadius="3xl" 
          boxShadow="2xl"
          bg="white"
          height={`${height}px`} 
          width={`${width}px`} 
          templateRows='repeat(4, 1fr)'
          style={{ gridAutoFlow: 'row' }} >
            <GridItem mt ="5px" rowSpan={1}>
            <Text style={{ userSelect: "none" }} as='b' fontSize={`${HeightCalculation(32,32)}px`} >
              {year}年{month}月{day}日{dayOfWeek}
            </Text>
            </GridItem>
            <GridItem rowSpan={3} position="relative">
              <Text style={{ userSelect: "none" }} position="absolute" top="-15%" left="50%" transform="translateX(-50%)" as='b' fontSize={`${HeightCalculation(92,92)}px`}>{formattedTime}</Text>
            </GridItem>
          </Grid>
        )
      }else{
        return (
          // 固定カード欄の時間表示(縦長)
          <Grid 
          mt="25px"
          textAlign="center" 
          borderRadius="3xl" 
          boxShadow="2xl"
          bg="white"
          height={`${height}px`} 
          width={`${width}px`} 
          templateRows='repeat(4, 1fr)'
          style={{ gridAutoFlow: 'row' }} >
            <GridItem rowSpan={3} position="relative">
              <Text style={{ userSelect: "none" }} position="absolute" top="25%" left="50%" transform="translateX(-50%)" as='b' fontSize={`${HeightCalculation(102,102)}px`}>{formattedTime}</Text>
            </GridItem>
            <GridItem rowSpan={1}>
            <Text style={{ userSelect: "none" }} m ="0px" as='b' fontSize={`${WidthCalculation(24,24)}px`} >
              {year}年{month}月{day}日{dayOfWeek}
            </Text>
            </GridItem>
          </Grid>
        )
      }
    }else{
      // headerの時間表示
      return(
        <Box w="100%" p={2} bg="black" textAlign="right">
          <Text 
          style={{
            userSelect:"none",
            color:"white",
            fontFamily: "Noto Sans JP",
            fontSize: `${HeightCalculation(24,24)}px`,
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "150%", /* 36px */
            letterSpacing: "0.96px",
          }} 
          pr="40px">
            {year}年{month}月{day}日{formattedTime}
          </Text>
        </Box>
      )
    }
};